import { Context, createContext, PropsWithChildren } from 'react'

import { Brand, DEFAULT_BRAND } from '../types/brand'

interface BrandContextType {
  brand: Brand
}

export const BrandContext: Context<BrandContextType> = createContext<BrandContextType>({ brand: DEFAULT_BRAND })

export default function BrandProvider ({ brand, children }: PropsWithChildren<BrandContextType>): JSX.Element {
  return (<BrandContext.Provider value={{ brand }}>{children}</BrandContext.Provider>)
}
